import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Modal } from "antd";


import { RingLoader } from "react-spinners";

import { Controller } from "react-hook-form";

import MultiFIlterSelect from "../../../components/multi-filter-select";
import useRequest from "../../../components/hooks/use-request";
import useApi from "../../../components/hooks/request";
import { showToast } from "../../../components/toast";
import Button from "../../../components/button";
import Icon from "../../../assets/icons";




interface AddRegionDialogProps {
    isVisible: boolean;
    onClose: () => void;
    regions?: any;
}
const AddOfficer: React.FC<AddRegionDialogProps> = ({
    isVisible,
    onClose,
    regions,
}) => {

    const {
        control,
        setValue,
        handleSubmit,
        trigger,
        clearErrors,
        formState: { errors },
    } = useForm({
        mode: "onChange",
    });
    const [roles, setRoles] = useState<{ _id: string; username: string; role: string }[]>([])
    const {loading, makeRequest} = useApi(`/region/${regions?._id}`, "PUT");
    const {  makeRequest: getUsers } = useRequest("/users", "GET");


    useEffect(() => {
        const fetchSuppliers = async () => {
          const [response] = await getUsers();
          if (response.status) {
            setRoles(response.data?.users);
          }
        };
        fetchSuppliers();
      }, []);
   

    const handleCreateRegion = handleSubmit(async (formData) => {
        const regions = {
            "sourcingOfficers": formData.sourcingOfficers
        }


        const [response] = await makeRequest(regions);
            if (response.status) {
            showToast(response.message, true, { position: "top-right" });
            onClose();
            window.location.reload();
        } else {
            showToast(response?.message, false, { position: "top-right" });
        }
    })

    

    const renderContent = () => {
        return (
            <div className="flex flex-col gap-5">
                <div className="items-center gap-4">
                <Controller
                    name="sourcingOfficers"
                    defaultValue={regions?.sourcingOfficers || []} // Ensure it's an array for multiple selections
                    control={control}
                    render={({ field }) => (
                        <MultiFIlterSelect
                            name="sourcingOfficers"
                            options={roles
                                .filter(role => role.role === 'sourcing-officer') // Filter roles by sourcing-officer
                                .map((role) => ({
                                    value: role._id, // Or whatever field in your role object represents the value
                                    label: role.username,
                                }))
                            }
                            className="w-full"
                            label="Sourcing Officer(s)"
                            onChange={(selectedValues) => {
                                // Convert the selected values to the format required
                                const selectedOfficers = selectedValues.map((id) => ({ _id: id }));
                                field.onChange(selectedOfficers); // Send data in the desired format
                            }}
                            value={field.value.map((officer: { _id: string }) => officer._id)}
                           
                           
                        />
                    )}
                />
            </div>
            </div>
        );
    }

    const renderFooterButton = () => {
        return (
            <div className="flex gap-3 py-2 mt-4">
                <Button
                    type="button"
                    variant="primary"
                    size="lg"
                    className="hover:bg-green-700 text-white flex items-center"
                    onClick={handleCreateRegion}
                    >
                    {loading ? (
                        <RingLoader color="#ffffff" loading={loading} size={20} />
                    ) : (
                        <div className="flex gap-3">
                        <Icon name="noteIcon" /> Add Sourcing Region 
                        </div>
                    )}
                </Button>
            </div>
        );
    }



    return (
        <Modal
          visible={isVisible}
          onCancel={onClose}
           width="80%"
        centered={true}
        footer={null}
        style={{
          padding: 0,
          margin: 0,
          maxWidth: "1200px",
          height: "auto",
        }}
        >
          <h1 className="text-2xl font-bold -mt-2 mb-4">Add Sourcing Officer</h1>
          
          <form onSubmit={handleCreateRegion}>
            <div className="grid gap-4">{renderContent()}</div>
            {renderFooterButton()}
          </form>
        </Modal>
    );
}
 
export default AddOfficer;